var map = {
	"./img1_desk@2x.png": 4989,
	"./img2_desk@2x.png": 5154,
	"./img3_desk@2x.png": 3691,
	"./img4_desk@2x.png": 2424,
	"./img5_desk@2x.png": 3481
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7376;